<template lang="pug">
    v-card.form-container
        v-form.px-3(ref="form" style="width: 100%")
            v-layout(row wrap)
                v-flex.pb-4.xs12.md12.text-sm-center 
                    span.title.grey--text.text-sm-center(v-show="message") Empleado no encontrado en los registros. No puede realizarse la transacción.
                v-flex(xs12 md12)
                    rut-input.mx-3(v-model="rut" @valid="onValidRut($event)" ref="rutInput")
                v-flex(xs12 md6)
                    v-text-field.mx-3(readonly label="Nombres"  v-model="employee.names")
                v-flex(xs12 md6)
                    v-text-field.mx-3(readonly label="Apellido Paterno" v-model="employee.last_name1")
                v-flex(xs12 md6)
                    v-text-field.mx-3(readonly label="Apellido Materno" v-model="employee.last_name2")
                v-flex(xs12 md6)
                    v-text-field.mx-3(readonly label="Descuento Autorizado" v-model="employee.discount" suffix="%")
</template>

<script>
import RUTInput from '@/components/RUTInput/RUTInput'
import InputValidations from '@/mixins/InputValidations'
import EmployeeService from '@/services/API/EmployeeService'
import { mapState, mapActions, mapGetters } from 'vuex'
import { addRUTHyphen } from '@/services/RUTFormatter.js'
export default {
    name: 'employee-form',
    props: {},
    data: function() {
        return {
            rut: '',
            message: false,
        }
    },
    computed: {
        ...mapState('EmployeeModule', {
            employee: 'employee',
            validEmployee: 'validEmployee',
        }),
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
    },
    methods: {
        onValidRut: async function(event) {
            if (!event) {
                this.resetState()
                return
            }
            if (this.rut.length <= 7) return
            const response = await EmployeeService.get([
                { field: 'rut', value: addRUTHyphen(this.rut) },
            ])
            if (response && response.data.data.length > 0) {
                let emp = response.data.data[0]
                this.setEmployee(emp)
                this.setValidEmployee(true)
                this.message = false
                if (this.activeTransaction.id === 5) {
                    this.setGlobalDiscount({ percentage_discount: 16 })
                }
            } else {
                this.resetState()
                this.message = true
                this.setGlobalDiscount({})
            }
        },
        ...mapActions('EmployeeModule', {
            setEmployee: 'setEmployee',
            setValidEmployee: 'setValidEmployee',
            resetState: 'resetState',
        }),
        ...mapActions('CartModule', {
            setGlobalDiscount: 'setGlobalDiscount',
        }),
    },
    watch: {},
    components: {
        'rut-input': RUTInput,
    },
    mixins: [InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        if (![4, 5].includes(this.activeTransaction.id))
            this.$router.replace('/cliente')
    },
    // beforeMount: function(){...},
    mounted: function() {
        this.$nextTick(() => this.$refs.rutInput.$refs.rut.focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
